import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M14 .053v12.614h17.895c.088 1.152.116 2.277.102 3.35a35 35 0 0 1-.114 3.316H14v12.614c-2.527-.112-4.937-.395-6.667-.86V19.332H.107a37 37 0 0 1-.104-3.35c-.014-1.055.02-2.17.114-3.316h7.216V.913C9.063.448 11.473.165 14 .053",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M12.667.129V14h19.305q.038 1.034.024 2.016.015.964-.03 1.984h-19.3v13.871c-1.445-.101-2.816-.262-4-.485V18H.03a38 38 0 0 1-.026-2.017c-.008-.64.001-1.304.03-1.983h8.634V.614C9.85.39 11.22.23 12.667.129",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagFro = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagFro_default = SvgFlagFro;

export { FlagFro_default as default };
